<template>
  <div
    class="data-table-show-off"
    @click="showOff()"
  >
    <div v-if="!isLoading">
      <md-icon :md-src="'/static/images/icon-accordion-' + state + '.svg'" />
    </div>
    <div v-if="isLoading">
      <spinner class="small" />
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/common/Spinner'

export default {
  name: 'DataShowOff',
  components: {
    Spinner
  },
  props: {
    isOpen: Boolean,
    isLoading: Boolean
  },
  computed: {
    state: function () {
      if (!this.isOpen) {
        return 'show'
      } else {
        return 'off'
      }
    }
  },
  methods: {
    showOff () {
      this.$emit('show-off')
    }
  }
}
</script>

<style lang="scss">
.data-table-show-off {
  cursor: pointer;
  margin-top: 0.5em;
  min-height: 3em;

  .md-icon {
    width: 15px;
    height: 15px;
    min-width: 15px;
    min-height: 15px;
  }
}

</style>

